
import { formatBoldText } from "./TextFormatter";

interface BulletPointProps {
  content: string;
}

const BulletPoint = ({ content }: BulletPointProps) => {
  // Format the bullet content with any bold text
  const formattedContent = formatBoldText(content);
  
  return (
    <div className="ml-4 my-1 flex">
      <span className="mr-2">•</span>
      <span>{formattedContent}</span>
    </div>
  );
};

export default BulletPoint;
